export default __webpack_public_path__ + "static/media/logoNewLight.659cbdc8.svg";